"use strict";
var browser_1 = require('./facade/browser');
function isBs3() {
    return browser_1.window.__theme !== 'bs4';
}
exports.isBs3 = isBs3;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/utils/ng2-bootstrap-config.js
// module id = 562
// module chunks = 0